import {Component, inject, OnInit, viewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {
  MatchingVccPaymentDetailReportComponent
} from "../matching-vcc-payment-detail-report/matching-vcc-payment-detail-report.component";


@AutoUnsubscribe()
@Component({
    selector: 'matching-vcc-payment-detail',
    templateUrl: './matching-vcc-payment-detail.component.html',
    standalone: false
})
export class MatchingVccPaymentComponent implements OnInit {
  paymentDetailReport = viewChild.required(MatchingVccPaymentDetailReportComponent);

  public data = inject<any>(MAT_DIALOG_DATA);
  private dialogRef: MatDialogRef<MatchingVccPaymentComponent> | null = inject(MatDialogRef<MatchingVccPaymentComponent>, {optional: true});

  public ngOnInit() {
    this.setModalData();
  }

  private setModalData() {
    const {
      connexPayAccountingDailyDetailId,
      fmsBookingId,
      merchantGuid,
      releasedDate,
      clientName,
      orderNumber,
      customerId,
      cardLastFour,
      version,
      description,
      cardGuid,
      connexpayChargeDateTime
    } = this.data;

    const prevConfig = this.paymentDetailReport().gridConfig();
    this.paymentDetailReport().gridConfig.set({
      ...prevConfig,
      filtersInitial: {
        connexPayAccountingDailyDetailId,
        fmsBookingId,
        merchantGuid,
        releasedDate,
        clientName,
        orderNumber,
        customerId,
        cardLastFour,
        version,
        description,
        cardGuid,
        connexpayChargeDateTime
      }
    })
  }

  protected closeDialog(): void {
    this.dialogRef?.close();
  }
}
